import { useConsentHooks } from "../Hooks/useConsentHooks"
import React, { useEffect } from "react"
import { useRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { useNavigation } from "@react-navigation/native"
import MainLoading from "@Screens/MainLoading/MainLoading"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"

const CheckingLastState = () => {
    const navigation = useNavigation()
    const isFocused = useNavigation()
    const [userData] = useRecoilState(userAtom)
    const { handleFetchConsent, updateData, patientConsent, fetchingPatientConsent: fetching } = useConsentHooks()

    function RedirectionHandler(hasConsent) {
        if (hasConsent) {
            navigation.navigate("Root", { screen: "Main" })
        } else {
            navigation.navigate("FirstConsent")
        }
    }

    LocalStorage.getConsentStatus()
        .then((currentConstentStatus) => {
            const hasConsent = currentConstentStatus?.condition && currentConstentStatus?.isUserMajor
            RedirectionHandler(hasConsent)
        })
        .catch(() => {
            console.log({ errorGetingStatusConstent: "errorGetingStatusConstent" })
            navigation.navigate("Root", { screen: "Main" })
        })

    useEffect(() => {
        handleFetchConsent()
    }, [userData, updateData, isFocused])

    return <MainLoading />
}

export default CheckingLastState
